<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3 text-md-right text-center">
              <button
                type="button"
                class="btn bg-white search-box border-secondary rounded-5 mr-3"
                style="height: 42px">
                <a class="text-secondary waves-effect waves-dark p-0" href="javascript:void(0)">
                  <i class="fas fa-search font-16"></i>
                </a>
                <form class="app-search position-absolute" v-on:submit.prevent>
                  <input
                    type="text"
                    class="form-control"
                    v-model="filterObj.search"
                    v-bind:placeholder="$lang.messages.search_enter"
                    v-on:keyup.enter="getList(1)" />
                  <a class="srh-btn">
                    <i class="ti-close"></i>
                  </a>
                </form>
              </button>
              <button
                @click="checkPendingAccountStatus($event, 'add-supplier')"
                class="btn btn-primary px-4">+ {{$lang.messages.add_supplier}}</button>
            </div>

            <div class="card rounded-5">
              <div class="card-body table-responsive">
                <table class="table table-striped table-style-1">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th
                        scope="col"
                        class="sorting"
                        @click="sorting($event, 'name')"
                      >{{$lang.messages.name}}</th>

                     <th
                        scope="col"
                        class="sorting"
                        @click="sorting($event, 'phone_number')"
                      >{{$lang.messages.mobile_number}}</th>
                      <th
                        scope="col"
                        class="sorting"
                        @click="sorting($event, 'email')"
                      >{{$lang.messages.email}}</th>
                     <th class="text-right">{{$lang.messages.action}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr  v-for="(obj,i) in list" :key="obj.id">
                      <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                      <td>{{obj.name}}</td>
                      <td>{{obj.phone_number}}</td>
                      <td>{{obj.email}}</td>

                      <td class="text-right pr-lg-4 text-nowrap">
                        <a
                          @click="edit(obj.id)"
                          href="javascript:void(0)"
                          class="text-primary mr-2 font-18">
                          <i class="mdi mdi-pencil"></i>
                        </a>
                        <i
                          class="far fa-trash-alt font-20 text-danger"
                          data-toggle="modal"
                          data-target="#delete-supplier-modal"
                          @click="setObj(obj.id, obj.name)"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>

            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Alert
      @rightButtonEvent="deleteSupplier($event)"
      ref="deleteSupplierAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-supplier-modal"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import router from "../../router";
import EventBus from "@/eventBus";
import accessible from '@/mixins/accessible'

export default {
  name: "supplier",
  components: {
    Pagination,
    ErrorComponent,
    Alert
  },
  data() {
    return {
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      colorList: [],
      currentSorting: "",
      filterObj: {},
      currentId: null
    };
  },

  mixins: [accessible],

  methods: {
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
     sorting(e, sortBy) {
      var orderBy = "ASC";
      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },
    getList(page, sortBy, orderBy) {
      this.list = [];
      this.currentPage = page;
        if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      this.$api
        .getAPI({
          _action: "/supplier/list/" + this.itemsPerPage + "/" + page,
           _body: this.filterObj
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(this.$lang.messages.no_supplier_found);
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },

    setObj(id, name) {
      this.currentId = id;
      this.$refs.deleteSupplierAlert.title = this.$lang.messages.delete_suppiler
      this.$refs.deleteSupplierAlert.message = this.$lang.messages.delete_suppiler_confirm
    },

    edit(id) {
      router.push("/supplier/edit/" + id);
    },
        retry() {
      this.getList(1);
    },

    deleteSupplier(e) {
      if (this.currentId) {
        this.$api
          .deleteAPI({
            _action: "/supplier/" + this.currentId
          })
          .then(res => {
            this.$refs.deleteSupplierAlert.close();
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });
            this.currentId = null;
            this.getList(1);
          })
          .catch(e => {
            this.$refs.deleteSupplierAlert.close();
          });
      }
    }
  },
  mounted() {
    $(".search-box a, .search-box .app-search .srh-btn").on(
      "click",
      function() {
        $(".app-search").toggle(200);
        $(".app-search input").focus();
      }
    );
    this.getList(1);

    // get current user profile
    EventBus.$on("GET_ME_SUCCESS", payload => {
      this.currentUser = payload
    });
  }
};
</script>
